import type { Rule } from 'antd/es/form';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { message } from 'ui';

export const useAttachmentsRules = (): Rule[] => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        message: '',
        validateTrigger: ['onSubmit'],
        // eslint-disable-next-line @typescript-eslint/require-await -- we need return promise with async function
        async validator(_, attachmentsContent) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
          if (attachmentsContent.loading) {
            message.error(
              'The attachment upload is still in progress. You can submit the post after the upload is finished.',
            );
            throw new Error(t('Error: The attachment upload is still in progress.'));
          }
        },
      },
    ],
    [t],
  );
};
